/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import DatePicker from "react-flatpickr";
import SoftDatePicker from "components/SoftDatePicker";
import { item } from "examples/Sidenav/styles/sidenavItem";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  fontSize: "14px",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: 0,
    stt: "",
    asset: "I. Lưu chuyển tiền từ hoạt động kinh doanh",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 1,
    stt: "01",
    asset: "1. Tiền thu từ bán hàng, cung cấp dịch vụ và doanh thu khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 2,
    stt: "02",
    asset: "2. Tiền chi trả cho người cung cấp hàng hóa và dịch vụ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 3,
    stt: "03",
    asset: "3. Tiền chi trả cho người lao động",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 4,
    stt: "04",
    asset: "4. Tiền lãi vay đã trả",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 5,
    stt: "05",
    asset: "5. Thuế thu nhập doanh nghiệp đã nộp",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 6,
    stt: "06",
    asset: "6. Tiền thu khác từ hoạt động kinh doanh",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 7,
    stt: "07",
    asset: "7. Tiền chi khác cho hoạt động kinh doanh",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 8,
    stt: "20",
    asset: "Lưu chuyển tiền thuần từ hoạt động kinh doanh (20=01+02+03+04+05+06+07)",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 9,
    stt: "",
    asset: "II. Lưu chuyển tiền từ hoạt động đầu tư",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 10,
    stt: "21",
    asset: "1. Tiền chi để mua sắm, xây dựng TSCĐ và các tài sản dài hạn khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 11,
    stt: "22",
    asset: "2. Tiền thu từ thanh lý, nhượng bán TSCĐ và các tài sản dài hạn khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 12,
    stt: "23",
    asset: "3. Tiền chi cho vay, mua các công cụ nợ của đơn vị khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 13,
    stt: "24",
    asset: "4. Tiền thu hồi cho vay, bán lại các công cụ của đơn vị khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 14,
    stt: "25",
    asset: "5. Tiền chi đầu tư góp vốn vào đơn vị khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 15,
    stt: "26",
    asset: "6. Tiền thu hồi đầu tư góp vốn vào đơn vị khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 16,
    stt: "27",
    asset: "7. Tiền thu lãi cho vay, cổ tức và lợi nhuận được chia",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 17,
    stt: "30",
    asset: "Lưu chuyển tiền thuần từ hoạt động đầu tư (30=21+22+23+24+25+26+27)",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 18,
    stt: "",
    asset: "III. Lưu chuyển tiền từ hoạt động tài chính",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 19,
    stt: "31",
    asset: "1. Tiền thu từ phát hành cổ phiếu, nhận vốn góp của chủ sở hữu",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 20,
    stt: "32",
    asset:
      "2. Tiền trả lại vốn góp cho các chủ sở hữu, mua lại cổ phiếu của doanh nghiệp đã phát hành",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 21,
    stt: "33",
    asset: "3. Tiền thu từ đi vay",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 22,
    stt: "34",
    asset: "4. Tiền trả nợ gốc vay",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 23,
    stt: "35",
    asset: "5. Tiền trả nợ gốc thuê tài chính",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 24,
    stt: "36",
    asset: "6. Cổ tức, lợi nhuận đã trả cho chủ sở hữu",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 25,
    stt: "40",
    asset: "Lưu chuyển tiền thuần từ hoạt động tài chính (40=31+32+33+34+35+36)",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 26,
    stt: "50",
    asset: "Lưu chuyển tiền thuần trong kỳ (50=20+30+40)",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 27,
    stt: "60",
    asset: "Tiền và tương đương tiền đầu kỳ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 28,
    stt: "61",
    asset: "Ảnh hưởng của thay đổi tỷ giá hối đoái quy đổi ngoại tệ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 29,
    stt: "70",
    asset: "Tiền và tương đương tiền cuối kỳ (70=50+60+61)",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
];

function Table3({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>Chi tiêu</Th>
              <Th style={{ textAlign: "center" }}>Mã số</Th>
              <Th style={{ textAlign: "center" }}>Thuyết minh</Th>
              <Th style={{ textAlign: "center" }}>Năm nay</Th>
              <Th style={{ textAlign: "center" }}>Năm trước</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>1</Th>
              <Th style={{ textAlign: "center" }}>2</Th>
              <Th style={{ textAlign: "center" }}>3</Th>
              <Th style={{ textAlign: "center" }}>4</Th>
              <Th style={{ textAlign: "center" }}>5</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((rows) => (
                <tr key={rows.id}>
                  <Td
                    style={{
                      textAlign: rows.assetCenter && rows.assetCenter === true ? "center" : "left",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.assetBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.asset}
                  </Td>
                  <Td
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.sttBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.stt}
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.presentBold === true ? "bold" : 400,
                    }}
                  >
                    <InputTable2
                      id={rows.id}
                      name="present"
                      readOnly={rows.presentReadOnly}
                      value={rows.value.present}
                      onChange={handleChange}
                      fontWeight={rows.presentBold}
                    />
                  </Td>
                  {rows.valueCenter && rows.valueCenter === true ? (
                    <>
                      <Td
                        style={{
                          textAlign: "center",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        {rows.value.now}
                      </Td>
                      <Td
                        style={{
                          textAlign: "center",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        {rows.value.before}
                      </Td>
                    </>
                  ) : (
                    <>
                      <Td
                        colSpan={1}
                        style={{
                          textAlign: "right",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        <InputTable
                          id={rows.id}
                          name="now"
                          readOnly={rows.readOnly}
                          value={rows.value.now}
                          onChange={handleChange}
                          fontWeight={rows.valueBold}
                        />
                      </Td>
                      <Td
                        colSpan={1}
                        style={{
                          textAlign: "right",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        <InputTable
                          id={rows.id}
                          name="before"
                          readOnly={rows.readOnly}
                          value={rows.value.before}
                          onChange={handleChange}
                          fontWeight={rows.valueBold}
                        />
                      </Td>
                    </>
                  )}
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
      <Footer formData={formData} />
    </Box>
  );
}

export default memo(Table3);

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function InputTable2(props) {
  const { id, onChange, type, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: "center",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        fontWeight: fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
